import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';
import Testimonial from './components/Testimonial';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "YOYBUY.PRO",
          "url": `${import.meta.env.VITE_SITE_URL}/`,
          "description": "YOYBUY Spreadsheet — умная система таблиц для заказа товаров из Китая. Обувь, одежда, аксессуары и многое другое.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": `${import.meta.env.VITE_SITE_URL}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "YOYBUY.PRO",
          "url": `${import.meta.env.VITE_SITE_URL}/`,
          "description": "Система таблиц для умных покупок из Китая",
          "sameAs": [
            "https://kaspreadsheet.com"
          ]
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Что такое YOYBUY Spreadsheet?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "YOYBUY Spreadsheet — это система таблиц для заказа товаров из Китая. Она позволяет сравнивать цены, отслеживать наличие и заказывать товары из 14 категорий через платформу Kaspreadsheet."
              }
            },
            {
              "@type": "Question",
              "name": "Как пользоваться YOYBUY Spreadsheet?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Выберите категорию товаров на YOYBUY.PRO, перейдите к таблице на Kaspreadsheet, фильтруйте товары по цене и параметрам, затем оформите заказ."
              }
            },
            {
              "@type": "Question",
              "name": "Сколько категорий товаров доступно?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "В YOYBUY Spreadsheet доступно 14 категорий: обувь, толстовки, футболки, куртки, брюки, головные уборы, комплекты, нижнее бельё, джерси, аксессуары, сумки, ремни, парфюмерия и другие товары."
              }
            }
          ]
        })}
      </script>
      <main>
        <Navbar />
        <Hero />
        <CategoryDropdown />
        <TrustSection />
        <CategoryGrid />
        <SeoContent />
        <Testimonial />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}